import LeafBackground from "../components/LeafBackground";

function Slogan({ setEnter }) {
    return (
        <div className="slogan-container" style={{ position: "relative", overflow: "hidden" }}>
            {/* <LeafBackground /> */}
            <div className="slogan fade-in-fast" style={{ position: "relative", zIndex: 1 }}>
                If the creator is perfect, then so is the creation.
            </div>
            <button
                onClick={() => setEnter(true)}
                className="enter fade-in-fast"
                style={{ position: "relative", zIndex: 1, fontSize: 16 }}
            >
                Proceed
            </button>
        </div>
    );
}

export default Slogan;
